import request from '@/util/request';

export const getRegionList = params => {
  return request({
    url: '/api/v4ward/car/ParkSpace/merge/regions/v2',
    method: 'get',
    params: params
  });
};
export const getParkParent = (params, options) =>
  request.get(
    '/api/v4ward/car/ParkSpace/merge/regionParentNodes/v2',
    Object.assign({}, options, {
      params
    })
  );
//获取区域
export const loadRegionByParentId = (parentId) => {
  return request({
    url: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId/v2',
    method: 'get',
    params: {
      parentId,
    },
  });
};

//获取最新客户端版本号
export const latestVersion = () => {
  return request({
    url: '/api/v4ward/car/ParkSpace/merge/latestVersions/v2',
    method: 'get',
  });
};

//获取v4ward道闸消息类型
export const v4wardMessageTypes = () => {
  return request({
    url: '/api/v4ward/car/ParkSpace/merge/messageTypes/v2',
    method: 'get',
  });
};


export const getPassages = param => {
  return request({
    url: '/api/v4ward/car/ParkSpace/merge/passages/v2',
    method: 'get',
    params: {
      parkId: param,
    }
  });
};

export const getPassRuleList = (params, options) =>
  request.get('/api/park/pass/rule/list/v2', Object.assign({}, options, {
    params
  }));

export const addPassRule = (params, options) =>
  request.post('/api/park/pass/rule/save/v2', params, options);

export const updatePassRule = (params, options) =>
  request.post('/api/park/pass/rule/update/v2', params, options);

export const stringCheck = (rule, value, callback) => {
  if (rule.min !== undefined && value.length < rule.min) {
    callback(new Error('字符长度不能少于' + rule.min));
    return;
  }
  if (rule.max !== undefined && value.length > rule.max) {
    callback(new Error('字符长度不能超过' + rule.max));
    return;
  }
  callback();
};

export const numberCheck = (rule, value, callback) => {
  if ((typeof value !== 'number' && isNaN(value))) {
    callback(new Error('请输入数字！'));
  } else if (value < rule.min || value > rule.max) {
    callback(new Error('有效数据' + rule.min + '-' + rule.max + '！'));
  } else {
    callback();
  }
};


export const getChildrenDeptByDeptId = (params, options) =>
  request.get('/api/v4ward/dept/getChildrenDeptByDeptId/v2', Object.assign({}, options, {
    params
  }));

export const getPassRuleDetail = (params, options) =>
  request.get('/api/park/pass/rule/detail/v2', Object.assign({}, options, {
    params
  }));

export const removeRegion = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/merge/removeRegion/v2', params, options);

export const removePassRule = (params, options) =>
  request.post('/api/park/pass/rule/remove/v2', params, options);

//  保存车场创建的步骤
export const saveCreateStage = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/saveCreateStage/v2', params, options);
// 获取车场创建的步骤
export const getCreateStage = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getCreateStage/v2', Object.assign({}, options, {
    params
  }));
